import classNames from "classnames";
import { ElementType } from "domelementtype";
import type { DOMNode } from "html-dom-parser";
import type { Element, HTMLReactParserOptions } from "html-react-parser";
import parse, { attributesToProps, domToReact } from "html-react-parser";
import React from "react";

import Button from "@components/atoms/Button";
import Image from "@components/atoms/Image";
import ImageSlider from "@components/molecules/ImageSlider";

function ParseContent({ html }: { html: string }) {
  const safelist = ["bg-primary!", "rounded-none!"];

  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      const domParse = domNode as Element;

      if (domParse.name === "img") {
        return <Image className="size-full" {...attributesToProps(domParse.attribs)} />;
      }

      if (domParse.name === "button") {
        const buttonText = domToReact(domParse.children as DOMNode[], options) as JSX.Element;
        return <Button className={domParse.attribs.class}>{buttonText}</Button>;
      }

      if (domParse.attribs && domParse.attribs.id === "slider") {
        const imageList = domToReact(domParse.children as DOMNode[], options) as JSX.Element[];
        const images = imageList.filter((item) => item.props).map((item) => item.props.src);
        return <ImageSlider images={images} />;
      }

      if (domParse.type === ElementType.Script) {
        const script = document.createElement("script");
        script.src = domParse.attribs.src;
        document.head.appendChild(script);
      }
    },
  };

  return (
    <>
      {parse(html, options)}
      <div className={classNames("hidden!", safelist)} />
    </>
  );
}

export default ParseContent;
